import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=ebaa7d96&scoped=true&"
import script from "./Triage.vue?vue&type=script&lang=js&"
export * from "./Triage.vue?vue&type=script&lang=js&"
import style0 from "./Triage.vue?vue&type=style&index=0&id=ebaa7d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa7d96",
  null
  
)

export default component.exports